module.exports = __webpack_public_path__ + "img/safe-harbor-firewall.2175e3ed.svg";